import React from "react";
import { ThreeDots } from "react-loader-spinner";

const Loader = ({ width, height, color }) => {
  return (
    <div
      style={{
        width: width || "100%",
        height: height || "400px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}>
      <ThreeDots
        color={color ? color : "#6200ee"}
        //strokeColor="#6200ee"
        strokeWidth="5"
        animationDuration="0.75"
        width="96"
        visible={true}
      />
    </div>
  );
};

export default Loader;
